export default "__VITE_ASSET__CkXUESIz__"